import React from "react";

import { MAGNET_PAGE_PATHS } from "./constants";
import MagnetPage from ".";

export default function ArticlePage() {
  return <MagnetPage path={MAGNET_PAGE_PATHS.ARTICLES} />;
}
